import { clsx } from 'clsx'

interface CardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  onClick?: () => void
}

export function Card({ children, className, hover = false, onClick }: CardProps) {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'bg-white border border-border-default rounded-[10px] p-5',
        hover &&
          'cursor-pointer transition-all duration-150 hover:border-border-hover hover:shadow-[0_4px_12px_rgba(0,0,0,0.06)] hover:-translate-y-px',
        onClick && 'cursor-pointer',
        className
      )}
    >
      {children}
    </div>
  )
}
